import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { transformation } from '../data/content';
export function Transformation() {
  const {
    title,
    before,
    after,
    closing
  } = transformation;
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-186" data-mp="mluyyh607wvl">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-187" data-mp="moh7ok4msife">
        <h2 className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 [text-wrap:balance] md:text-5xl" data-id="element-188" data-mp="rm0jzehrql4p">
          {title}
        </h2>

        <div className="mx-auto mt-10 grid max-w-4xl gap-4 md:mt-12 md:grid-cols-2 md:gap-5" data-id="element-189" data-mp="11iddocdbcyzg">
          <div className="flex h-full flex-col rounded-2xl bg-slate-50 p-6 ring-1 ring-slate-200 md:p-7" data-id="element-190" data-mp="16b6hmy0yk3ah">
            <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-red-600" data-id="element-191" data-mp="1aanqm1flfike">{before.label}</p>
            <h3 className="mt-2 text-xl font-extrabold tracking-tight text-slate-900 md:text-2xl" data-id="element-192" data-mp="1fc4qbtmccyze">
              {before.title}
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-193" data-mp="1c60gsmfmci4q">
              {before.points.map(point => <li key={point} className="flex items-start gap-3 text-slate-600" data-id="element-194" data-mp="1c3nrfo7j75hn">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-195" data-mp="1791om9fiml96" />
                  <span className="leading-snug" data-id="element-196" data-mp="135lp95c2a6ss">{point}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex h-full flex-col rounded-2xl bg-blue-600 p-6 text-white shadow-lg md:p-7" data-id="element-197" data-mp="1uw9ryltdvk8k">
            <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-blue-100" data-id="element-198" data-mp="1qv6eg5yt60ai">{after.label}</p>
            <h3 className="mt-2 text-xl font-extrabold tracking-tight md:text-2xl" data-id="element-199" data-mp="1m3o8f3hxh9io">{after.title}</h3>
            <ul className="mt-5 space-y-3" data-id="element-200" data-mp="1h5mq4ksbte89">
              {after.points.map(point => <li key={point} className="flex items-start gap-3" data-id="element-201" data-mp="2el0oygvnncrl">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white text-blue-600" data-id="element-202" data-mp="2embscfl6uii6">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-203" data-mp="2spivkodc02vw" />
                  </span>
                  <span className="font-medium leading-snug" data-id="element-204" data-mp="2xpnai9ylcpk0">{point}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-3xl text-center text-xl font-extrabold leading-snug tracking-tight text-blue-600 [text-wrap:balance] md:mt-12 md:text-3xl" data-id="element-205" data-mp="2jvmn2cd3aoyy">
          {closing}
        </p>
      </div>
    </section>;
}